module.exports = __webpack_public_path__ + "e804875bd778840a6c2848fb83bbde68.png";